import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ApiService } from '@core/services/api.service';
import { of } from 'rxjs';
import { TypeFieldEnum } from '@shared/components/dynamic-form/components/dynamic-form/dynamic-form.component';

const baseUrl = `/produtos`;
const routes = {
  insert: baseUrl,
  edit: (idProduto: number) => `${baseUrl}/${idProduto}`,
  consult: `${baseUrl}/consultar`,
  consultId: (idProduto: number) => `${baseUrl}/${idProduto}`,
  mudarStatus: (idProduto: number) => `${baseUrl}/${idProduto}`,
  consultTodos: baseUrl,
  tipos: '/tipos-produto',
  trocar: (idProduto: number) => `${baseUrl}/trocar/${idProduto}`,
  produtosUsuario: `${baseUrl}/usuario-logado`,
}

@Injectable({
  providedIn: 'root'
})
export class ProdutoService {

  constructor(private apiService: ApiService) { }

  cadastrar(obj: any) {
    return this.apiService.post(routes.insert, obj);
  }

  editar(idProduto: number, obj: any) {
    return this.apiService.put(routes.edit(idProduto), obj);
  }

  consultar(obj: any, page: number, pageSize: number) {
    let params = new HttpParams();
    params = params.append('size', pageSize);
    params = params.append('page', page - 1);
    return this.apiService.post<any>(routes.consult, obj, undefined, undefined, params);
  }

  consultarPorId(idProduto: number) {
    return this.apiService.get<any>(routes.consultId(idProduto));
  }

  mudarStatus(idAnimal: number, obj: any) {
    return this.apiService.patch(routes.mudarStatus(idAnimal), obj);
  }

  consultTodos() {
    return this.apiService.get<any>(routes.consultTodos);
  }

  tiposProdutos() {
    return this.apiService.get<any>(routes.tipos);
  }

  trocarProduto(id: number) {
    return this.apiService.put<any>(routes.trocar(id));
  }

  consultProdutosUsuario() {
    return this.apiService.get<any>(routes.produtosUsuario);
  }

  fieldsListForm() {
    return of([
      { name: 'descricao', label: 'Produto', type: TypeFieldEnum.Input, required: false, order: 1 },
      { name: 'tipoProduto', label: 'Tipo Produto', type: TypeFieldEnum.Select, list: 'tipoProdutoLista', optionValueFn: 'item', required: false, order: 2 },
      { name: 'ativo', label: 'Status', type: TypeFieldEnum.Select, list: 'statusLista', required: false, order: 3 }
    ])
  }
}
